import { emptyStepState, mergeStepState, type StepState } from '@engpod/core';

/** Device-local learning state: works for guests and survives being offline. */
interface LocalProgress {
  positionMs: number;
  stepState: StepState;
  updatedAt: number;
}

const key = (episodeId: string) => `engpod.progress.${episodeId}`;

export function readLocal(episodeId: string): LocalProgress {
  try {
    const raw = localStorage.getItem(key(episodeId));
    if (raw) return JSON.parse(raw) as LocalProgress;
  } catch {
    /* ignore corrupt entries */
  }
  return { positionMs: 0, stepState: emptyStepState(), updatedAt: 0 };
}

export function writeLocal(episodeId: string, value: Partial<LocalProgress>) {
  const prev = readLocal(episodeId);
  const next: LocalProgress = {
    positionMs: value.positionMs ?? prev.positionMs,
    stepState: value.stepState ? mergeStepState(value.stepState, prev.stepState) : prev.stepState,
    updatedAt: Date.now(),
  };
  localStorage.setItem(key(episodeId), JSON.stringify(next));
  return next;
}

export const prefs = {
  get<T>(name: string, fallback: T): T {
    try {
      const raw = localStorage.getItem(`engpod.pref.${name}`);
      return raw === null ? fallback : (JSON.parse(raw) as T);
    } catch {
      return fallback;
    }
  },
  set(name: string, value: unknown) {
    localStorage.setItem(`engpod.pref.${name}`, JSON.stringify(value));
  },
};
